import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { selectMarketApiRequestsLoading } from "../../../store/market-api/overviewSlice";
import {
  getWalletApiRequestsAysnc,
  getWalletApiUsageAysnc,
  selectWalletApiRequests,
} from "../../../store/wallet-api/overviewSlice";
import IpfsReportedUsageWidget from "./ReportedUsageWidget";
import WalletApiBanner from "./WalletApiBanner";
import { Typography, SimpleTable, Card, EmptyState } from "djuno-design";
import { formatTimestamp } from "../../../utils/date";

const WalletApiOverviewTab = () => {
  const requests = useAppSelector(selectWalletApiRequests);
  const requestsLoading = useAppSelector(selectMarketApiRequestsLoading);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getWalletApiUsageAysnc());
    dispatch(getWalletApiRequestsAysnc());
  }, [dispatch]);

  return (
    <div className="flex flex-col gap-8">
      <WalletApiBanner />
      <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4">
        <IpfsReportedUsageWidget />
      </div>
      <Card title="API Request Log">
        <SimpleTable
          loading={requestsLoading}
          className="table-auto"
          containerClassName="min-h-[240px]"
        >
          <SimpleTable.Head>
            <SimpleTable.Row>
              <SimpleTable.TH lable="Last 100 API Requests" />
              <SimpleTable.TH lable="Timestamp" />
            </SimpleTable.Row>
          </SimpleTable.Head>
          <SimpleTable.Body>
            {requests.map((request, index) => (
              <SimpleTable.Row key={index}>
                <SimpleTable.TD>
                  <Typography.Text className="!text-xs md:!text-sm">
                    {request.Request}
                  </Typography.Text>
                </SimpleTable.TD>
                <SimpleTable.TD>
                  <Typography.Text className="!text-xs md:!text-sm">
                    {formatTimestamp(request.Timestamp).datetime}
                  </Typography.Text>
                </SimpleTable.TD>
              </SimpleTable.Row>
            ))}
            {requests.length === 0 && (
              <SimpleTable.Row withoutHoverStyle={true} className="h-[200px]">
                <SimpleTable.TD colSpan={2} className="!border-none">
                  <EmptyState />
                </SimpleTable.TD>
              </SimpleTable.Row>
            )}
          </SimpleTable.Body>
        </SimpleTable>
      </Card>
    </div>
  );
};

export default WalletApiOverviewTab;
